import React, {PropsWithChildren, useContext} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {ItemSection} from "../models/item.model";

export const ItemsContext = React.createContext({} as ItemSection);

export const ItemsProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <ItemsContext.Provider value={data.itemSection}>
            {children}
        </ItemsContext.Provider>
    )
}